/* eslint-disable react-hooks/rules-of-hooks */
import { updateProfile, updateRuntime } from "@src/redux/actions";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import Form from "zq-ui-v3/components/Form/Form";
import View from "zq-ui-v3/components/View/View";
import Button from "zq-ui-v3/components/Button/Button";
import { showAlert } from "zq-ui-v3/components/Alert/Alert";
import { callApiByPath } from "@src/api/axios";

const Profile: React.FC = () => {
  const dispatch = useDispatch();
  dispatch(updateRuntime({ pageTitle: "个人中心" }));

  const profile = useSelector((state: any) => state.profile);
  const logout = () => {
    showAlert({
      type: "warn",
      content: "是否确认注销登录？",
      onOk: async () => {
        sessionStorage.removeItem("token");
        dispatch(updateProfile({}));
        await callApiByPath("post", "/account/User/logout");
      },
    });
  };
  return (
    <View className="m-auto my-2 shadow-sm rounded-sm" style={{ maxWidth: 900 }}>
      <Form
        hideToolbar
        formData={profile}
        readOnly
        mdataList={[
          { name: "name", title: "名称" },
          { name: "phone", title: "手机" },
        ]}
      />
      <View className="p-2 con-center">
        <Button title="注销登录" color="error" onClick={logout} showType="outlined" />
      </View>
    </View>
  );
};
export default Profile;
